import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-96d72d60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "backgrnd" }
const _hoisted_2 = {
  key: 0,
  class: "spin"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "general" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "side" }
const _hoisted_8 = { class: "card bg-secondary cardOpciones" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Especialistas de Llamada ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-users" }, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Especialistas")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "main" }
const _hoisted_16 = {
  key: 0,
  class: "modal"
}
const _hoisted_17 = { class: "contenedor" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Filtros", -1))
const _hoisted_19 = { class: "contenido" }
const _hoisted_20 = { class: "contenido" }
const _hoisted_21 = { class: "card bg-secondary" }
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Servicios ")
const _hoisted_24 = { class: "grid" }
const _hoisted_25 = { class: "llamadas" }
const _hoisted_26 = { class: "grid-fields" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "desde"
}, "Fecha:", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "especialidad"
}, "Especialidad:", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "especialista"
}, "Especialista:", -1))
const _hoisted_30 = { class: "mycard-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Filters = _resolveComponent("Filters")!
  const _component_ListadoComponent = _resolveComponent("ListadoComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        ($data.cargando)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_Navbar),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _createElementVNode("h4", null, [
                  _hoisted_10,
                  _createElementVNode("i", {
                    style: {"cursor":"pointer","margin-left":"10px"},
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.toggleSubmenu())),
                    class: "fas fa-times",
                    _mstvisible: "2"
                  })
                ]),
                _hoisted_11,
                _createElementVNode("nav", {
                  class: _normalizeClass($data.navMenuClas2)
                }, [
                  (
                      this.$store.state.user.type == 'Power User' ||
                        this.$store.state.user.type == 'Encargado' ||
                        this.$store.state.user.type == 'Presidente' ||
                        this.$store.state.user.type == 'Director Médico' ||
                        this.$store.state.user.type == 'Especialista'
                    )
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "navbar-option",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (this.hamburger('Especialistas'))),
                        href: "#"
                      }, _hoisted_14))
                    : _createCommentVNode("", true)
                ], 2)
              ])
            ], 512), [
              [_vShow, $data.showSubmenu]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          ($data.showModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (this.showModalMethod())),
                      for: "btn-modal"
                    }, "X"),
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_Filters, {
                        filterLlamadas: $options.filterLlamadas,
                        search: $options.search,
                        filteredLlamadas: _ctx.filteredLlamadas
                      }, null, 8, ["filterLlamadas", "search", "filteredLlamadas"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", null, [
                _createElementVNode("h4", null, [
                  _createElementVNode("i", {
                    style: {"cursor":"pointer","margin-left":"30px","position":"fixed","left":"0px"},
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.toggleSubmenu())),
                    class: "fas fa-bars",
                    _mstvisible: "2"
                  }),
                  _hoisted_23
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", null, [
                        _hoisted_27,
                        _withDirectives(_createElementVNode("input", {
                          id: "desde",
                          type: "date",
                          onChange: _cache[4] || (_cache[4] = ($event: any) => ($options.loadLlamadas())),
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.criterio.desde) = $event)),
                          class: "form-control"
                        }, null, 544), [
                          [_vModelText, $data.criterio.desde]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_28,
                        _withDirectives(_createElementVNode("input", {
                          id: "especialidad",
                          type: "especialidad",
                          onChange: _cache[6] || (_cache[6] = ($event: any) => ($options.filtrarEsp())),
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.criterio.especialidad) = $event)),
                          class: "form-control"
                        }, null, 544), [
                          [_vModelText, $data.criterio.especialidad]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_29,
                        _withDirectives(_createElementVNode("select", {
                          id: "especialista",
                          type: "especialidad",
                          onChange: _cache[8] || (_cache[8] = ($event: any) => ($options.loadServsByEsp())),
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($data.criterio.especialista) = $event)),
                          class: "form-select"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.especialistas, (especialista, index) => {
                            return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(especialista.nombre), 1))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, $data.criterio.especialista]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _withDirectives(_createVNode(_component_ListadoComponent, { llamadas: $data.llamadas }, null, 8, ["llamadas"]), [
                        [_vShow, !$data.cargando]
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], 512), [
      [_vShow, !$data.cargando]
    ])
  ]))
}